/* eslint-disable no-inner-declarations */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
// Above global eslint rules disabled as GlideJS has no TS implementation
/**
 * Carousel Component
 * @module patterns/components/media-gallery
 */
// eslint-disable-next-line @typescript-eslint/ban-tslint-comment
/* tslint:disable:no-any */

// Dependencies
import Glide from '@glidejs/glide';

// Local Dependencies
import { markElementReady } from '@root/src/framework/scripts/helpers/element-ready';
import { parseToObject } from '@root/src/framework/scripts/utils/parse';
import { scrollIntoView } from '~/framework/utils/scroll';
/**
 * Initialises the Carousel component
 */
import { type App } from '~/app';

import JsController from '../js-controller';

import { CLASS_NAME, OPTIONS } from './constants';

// eslint-disable-next-line import/no-unassigned-import
import './media-gallery.scss';

export default (app: App) => {
	const controller = new JsController(app, 'Media Gallery');
	controller.addMountFunction(() => {
		mountMediaGallery(controller);
	});

	return controller.init();
};

export const carousels = new Map<string, Glide>();

export function mountMediaGallery(controller: JsController) {
	const elements = document.querySelectorAll<HTMLElement>(`.${CLASS_NAME}`);
	const mediaGallery = document.querySelectorAll<HTMLElement>('.media-gallery');

	// Loop through and individually instantiate each Glide instance
	const initialiseMediaGallery = (elements: NodeListOf<HTMLElement>) => {
		for (const gallery of mediaGallery) {
			for (const element of elements) {
				const carouselOptions = parseToObject<any>(element.dataset.carouselOptions);
				const carouselId = element.dataset.carouselId ?? '';
				const slides = element.querySelectorAll<HTMLElement>('.carousel__slide:not(.glide__slide--clone)');

				const indexClass = `${CLASS_NAME}-${carouselId}`;
				element.classList.add(indexClass);

				const existingGlides = carousels.get(indexClass)!;
				if (existingGlides) {
					existingGlides.destroy();
				}

				const glide = new Glide(`.${indexClass}`, {
					...OPTIONS,
					...carouselOptions,
					type: 'carousel',
					perView: 1,
				});

				//Display current slide index
				const updateNumberIndicatorIndex = (slides: NodeListOf<HTMLElement>) => {
					const slideIndex = element.querySelector('.slide-index');

					if (slideIndex && slides) {
						slideIndex.innerHTML = `${Number(glide.index) + 1} / ${slides.length}`;
					}
				};

				const viewMoreButton = gallery.querySelectorAll<HTMLElement>('.view-more-btn');
				for (const button of viewMoreButton) {
					refreshCarouselOnClick(button);
				}

				const galleryImage = gallery.querySelectorAll<HTMLElement>('.gallery-images');
				for (const [index, image] of galleryImage.entries()) {
					refreshCarouselOnClick(image, index);
				}

				function refreshCarouselOnClick(element: HTMLElement, slideStart?: number) {
					controller.addListener(element, 'click', () => {
						setTimeout(() => {
							glide.update({
								startAt: slideStart ?? 0,
							});
						}, 400);
					});
				}

				// eslint-disable-next-line @typescript-eslint/no-loop-func,unicorn/consistent-function-scoping
				const scrollImageIntoView = (element: HTMLElement) => {
					scrollIntoView(element, {
						behavior: 'smooth',
						inline: 'center',
						block: 'nearest',
					});
				};

				// Observe class change in image thumbnails
				const galleryPictures = gallery?.querySelectorAll<HTMLElement>('.gallery-thumbnail-list > div');
				const galleryImageDescription = gallery.querySelectorAll<HTMLElement>('.image-description');
				const slideIndex = gallery.querySelector('.slide-index');

				if (galleryPictures)
					for (const picture of galleryPictures) {
						const observer = new MutationObserver(function () {
							if (picture.classList.contains('glide__bullet--active')) {
								scrollImageIntoView(picture);
								for (const description of galleryImageDescription) {
									if (description.dataset.imageIndex === picture?.dataset.imageIndex) {
										description?.classList.remove('hidden');
									} else if (!description.classList.contains('hidden')) {
										description?.classList.add('hidden');
									}
								}

								if (picture.classList.contains('video-thumbnail')) {
									slideIndex?.classList.add('hidden');
								} else {
									slideIndex?.classList.remove('hidden');
								}
							}
						});
						observer.observe(picture, {
							attributes: true,
							attributeFilter: ['class'],
						});
					}

				glide.on('update', function () {
					updateNumberIndicatorIndex(slides);
				});

				glide.on('swipe.end', function () {
					updateNumberIndicatorIndex(slides);
				});

				glide.on('move.after', function () {
					updateNumberIndicatorIndex(slides);
				});

				// On screensize re-initialise the carousel to handle per view updates on different screensizes
				const glideUpdate = () => glide.update();

				controller.addListener(window, 'resize', glideUpdate);

				setTimeout(() => {
					glide.mount();
					glide.update();
				}, 500);

				carousels.set(indexClass, glide);

				markElementReady(element);
			}
		}
	};

	initialiseMediaGallery(elements);

	const modal = document.querySelector<HTMLElement>('#media-gallery-modal-id');
	if (modal) {
		console.log('mounting to modal');
		if (!modal.dataset.listenerAdded) {
			controller.addListener(modal, 'hidden.bs.modal', () => {
				const allVideoControls = document.querySelectorAll('.plyr__control');
				for (const button of allVideoControls) {
					if (button.classList.contains('plyr__control--pressed')) {
						button.dispatchEvent(new Event('click'));
					}
				}
			});
			modal.dataset.listenerAdded = 'true';
		}
	}
}
